module.exports = __webpack_public_path__ + "img/ic_topic_training.2d5c2914.svg";